// @flow
import * as React from 'react';
import Group from 'sail/Group';
import {InfoTooltip} from 'sail/Tooltip';

type RadarInfoTooltipProps = {|
  text: string,
|};

export const RadarInfoTooltip = ({text}: RadarInfoTooltipProps) => {
  return (
    <Group
      alignItems="center"
      direction="horizontal"
      spacing={12}
      style={{paddingLeft: '4px'}}
    >
      <InfoTooltip content={text} />
    </Group>
  );
};
